<template>
<div class="dashboard_content">
  <div class="dashboardStatus">
    <h1 class="contentTitle">ご利用状況</h1>
    <div class="statusItem">
      <div class="statusTitle"><img class="itemIcon" :src="workerIcon">
      アクティブな利用者</div>
      <div class="status_detail"><span class="value" v-text="activeUser"></span>人</div>
    </div>
    <div class="statusItem">
      <div class="statusTitle"><img class="itemIcon" :src="callIcon">
      電話回数</div>
      <div class="supplyment">本日：{{ todayCall }}回</div>
      <div class="supplyment">週間：{{ weekCall }}回</div>
      <div class="supplyment">月間：{{ monthCall }}回</div>
    </div>
    <div class="statusItem">
      <div class="statusTitle"><img class="itemIcon" :src="belnongIcon">
      メッセージ通知回数</div>
      <div class="supplyment">本日：{{ todayMsg }}回</div>
      <div class="supplyment">週間：{{ weekMsg }}回</div>
      <div class="supplyment">月間：{{ monthMsg }}回</div>
    </div>
    <div class="statusItem">
      <div class="statusTitle"><img class="itemIcon" :src="deviceIcon">
      契約台数・現在の登録台数</div>
      <div class="supplyment">契約台数：{{ availableDeviceCounts }}台</div>
      <div class="supplyment">現在の登録台数：{{ registerDeviceCount }}台</div>
    </div>
    <div class="clearFix"/>
  </div>
</div>
</template>

<script>
export default {
  props: {
    userCount: Object,
    callCount: Object,
    msgCount: Object,
    deviceCount: Object
  },
  data () {
    return {
      workerIcon: require('../../img/careworker.png'),
      callIcon: require('../../img/callPhone.png'),
      belnongIcon: require('../../img/belong.png'),
      deviceIcon: require('../../img/device.png')
    }
  },
  computed: {
    activeUser () {
      if (this.userCount != null) {
        return this.userCount.current
      }
      return '-'
    },
    todayCall () {
      if (this.callCount != null) {
        return this.callCount.today
      }
      return '-'
    },
    weekCall () {
      if (this.callCount != null) {
        return this.callCount.week
      }
      return '-'
    },
    monthCall () {
      if (this.callCount != null) {
        return this.callCount.month
      }
      return '-'
    },
    todayMsg () {
      if (this.msgCount != null) {
        return this.msgCount.today
      }
      return '-'
    },
    weekMsg () {
      if (this.msgCount != null) {
        return this.msgCount.week
      }
      return '-'
    },
    monthMsg () {
      if (this.msgCount != null) {
        return this.msgCount.month
      }
      return '-'
    },
    availableDeviceCounts () {
      if (this.deviceCount != null) {
        return this.deviceCount.availableDeviceCounts
      }
      return '-'
    },
    registerDeviceCount () {
      if (this.deviceCount != null) {
        return this.deviceCount.registerDeviceCount
      }
      return '-'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/dashboardStatus.vue